export default "__VITE_ASSET__33f092c9__"